import React, { ReactNode } from "react";
import Button from "@mui/material/Button";
import { AppButtonVariants } from "../../../../utils/ThemeContext";
import { SxProps, Theme } from "@mui/material";

interface AppButtonProps {
  label: any;
  onClick: () => void;
  startIcon?: ReactNode | string;
  endIcon?: ReactNode | string;
  disabled?: boolean;
  fontSize?: string | number;
  fontWeight?: number;
  customStyles?: SxProps<Theme>;
  variant?: AppButtonVariants;
}

const AppButton: React.FC<AppButtonProps> = ({
  label,
  onClick,
  startIcon,
  endIcon,
  disabled = false,
  fontSize = "0.8rem",
  fontWeight = 650,
  customStyles = {},
  variant = "primary",
}) => {
  const renderIcon = (icon: ReactNode | string) => {
    if (typeof icon === "string") {
      return <img src={icon} alt="" style={{ height: 16, width: 16 }} />;
    }

    return React.cloneElement(icon as React.ReactElement, {
      style: {
        height: 16,
        width: 16,
        color: "inherit",
      },
    });
  };

  return (
    <Button
      onClick={onClick}
      startIcon={startIcon ? renderIcon(startIcon) : null}
      endIcon={endIcon ? renderIcon(endIcon) : null}
      disabled={disabled}
      variant={variant}
      sx={{
        textTransform: "none",
        fontSize: fontSize,
        fontWeight: fontWeight,
        minHeight: "40px",
        ...customStyles,
        borderRadius: "8px",
        "& .MuiButton-startIcon": {
          marginRight: "5px",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiButton-endIcon": {
          marginLeft: "5px",
          display: "flex",
          alignItems: "center",
        },
      }}
    >
      {label}
    </Button>
  );
};

export default AppButton;
